$(document).on('click', '.js-quantity-picker button:not(.disabled)', function(){

    let quantity_picker_wrapper = $(this).parents('.js-quantity-picker');
    let input = $('input', quantity_picker_wrapper);
    let input_val = parseInt(input.val());
    let type = $(this).data('type');
    input.val(type ? input_val + 1 : input_val - 1);
    input.trigger('input');
});

$(document).on('input', '.js-quantity-picker input', function(){
    // clearTimeout(term_input_timeout);

    let quantity_picker = $(this).parent('.js-quantity-picker');
    let input = $(this);
    let input_value = input.val().replace(/[^0-9\.]/g,'');
    input_value = parseFloat(input_value);
    let notif_showed = false;

    let min = parseFloat(input.attr('min'));
    let max = parseFloat(input.attr('max'));

    if(isNaN(input_value)) {
        input_value = min;
    }

    if(input_value > max){
        input_value = max;
    }

    if(input_value <= max){
        $('button[data-type="1"]', quantity_picker).removeClass('disabled');
    }

    if(input_value > min){
        $('button[data-type="0"]', quantity_picker).removeClass('disabled');
    }

    if (input_value >= max) {

        if(!notif_showed){
            let notif_text = input.data('max-notif');
            if(notif_text){
                notif('warning', input.data('max-notif'));
                notif_showed = true;
            }
        }

        input_value = max;
        $('button[data-type="1"]', quantity_picker).addClass('disabled');

    } else if (input_value <= min) {
        input_value = min;
        $('button[data-type="0"]', quantity_picker).addClass('disabled');
    }

    let quantity_pickers_wrapper = $(this).parents('.js-quantity-pickers-wrapper');
    if(quantity_pickers_wrapper.length !== 0){

        let quantity_picker_max_total = quantity_pickers_wrapper.data('max-total');

        if(quantity_picker_max_total){

            let quantity_pickers_total = 0;
            $('.js-quantity-picker', quantity_pickers_wrapper).each(function(){
                let input_val = $('input[type="number"]', this).val();
                quantity_pickers_total += parseInt(input_val);
            })

            if(quantity_pickers_total >= quantity_picker_max_total){
                $('.js-quantity-picker button[data-type="1"]', quantity_pickers_wrapper).addClass('disabled');
                let notif_input = $('.js-quantity-picker-max-total-notif', quantity_pickers_wrapper);
                if(notif_input.length && !notif_showed){
                    notif('warning', notif_input.val());
                    notif_showed = true;
                }
                if(quantity_pickers_total > quantity_picker_max_total){
                    input_value--;
                }
            }else {
                $(this).removeClass('disabled');

                $('.js-quantity-picker', quantity_pickers_wrapper).each(function(){
                    let loop_input = $('input[type="number"]', this);
                    let loop_input_val = loop_input.val();

                    if(parseInt(loop_input_val) < loop_input.attr('max')) {
                        $('button[data-type="1"]', this).removeClass('disabled');
                    }
                })
            }
        }
    }

    input.val(input_value);

});
